<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.iq_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd">
          <div class="weui-form-preview__item" slot="iq_station">
            <label class="weui-form-preview__label">{{customLabel.iq_station || "工位"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iq_station
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="iq_frequency">
            <label class="weui-form-preview__label">{{customLabel.iq_frequency || "检查频次"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iq_frequency
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="iq_prodcode">
            <label class="weui-form-preview__label">{{customLabel.iq_prodcode || "物料编号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iq_prodcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "物料名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_detail
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="iq_classes">
            <label class="weui-form-preview__label">{{customLabel.iq_classes || "班次"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iq_classes
            }}</span>
          </div>
          
          <div class="weui-form-preview__item" slot="iq_person">
            <label class="weui-form-preview__label">{{customLabel.iq_person || "生产负责人"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iq_person
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="iq_custname">
            <label class="weui-form-preview__label">{{customLabel.iq_custname || "客户"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.iq_custname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="iq_date">
            <label class="weui-form-preview__label">{{customLabel.iq_date || "检验日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.iq_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="iq_remark">
            <label class="weui-form-preview__label">{{customLabel.iq_remark || "备注"}}</label>
            <span class="weui-form-preview__value">{{ form.main.iq_remark }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.iqd_detno }}</div>
           <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="iqd_time">
            <label class="weui-form-preview__label">{{customLabel.iqd_time || "检查时间"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd hh:mm:ss'">{{ item.iqd_time }}</span>
          </div>
          <div class="weui-form-preview__item" slot="iqd_item">
            <label class="weui-form-preview__label">{{customLabel.iqd_item || "检查项目"}}</label>
            <span class="weui-form-preview__value">{{ item.iqd_item }}</span>
          </div>
          <div class="weui-form-preview__item" slot="iqd_standard">
            <label class="weui-form-preview__label">{{customLabel.iqd_standard || "检查标准"}}</label>
            <span class="weui-form-preview__value">{{ item.iqd_standard }}</span>
          </div>
          <div class="weui-form-preview__item" slot="iqd_result">
            <label class="weui-form-preview__label">{{customLabel.iqd_result || "检验结果"}}</label>
            <span class="weui-form-preview__value">{{
              item.iqd_result
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.iqd_sample1" slot="iqd_sample1">
            <label class="weui-form-preview__label">{{customLabel.iqd_sample1 || "样本1"}}</label>
            <span class="weui-form-preview__value">{{
             item.iqd_sample1
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.iqd_sample2" slot="iqd_sample2">
            <label class="weui-form-preview__label">{{customLabel.iqd_sample2 || "样本2"}}</label>
            <span class="weui-form-preview__value">{{
             item.iqd_sample2
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.iqd_sample3" slot="iqd_sample3">
            <label class="weui-form-preview__label">{{customLabel.iqd_sample3 || "样本3"}}</label>
            <span class="weui-form-preview__value">{{
             item.iqd_sample3
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.iqd_sample4" slot="iqd_sample4">
            <label class="weui-form-preview__label">{{customLabel.iqd_sample4 || "样本4"}}</label>
            <span class="weui-form-preview__value">{{
             item.iqd_sample4
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.iqd_sample5" slot="iqd_sample5">
            <label class="weui-form-preview__label">{{customLabel.iqd_sample5 || "样本5"}}</label>
            <span class="weui-form-preview__value">{{
             item.iqd_sample5
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.iqd_sample6" slot="iqd_sample6">
            <label class="weui-form-preview__label">{{customLabel.iqd_sample6 || "样本6"}}</label>
            <span class="weui-form-preview__value">{{
             item.iqd_sample6
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.iqd_sample5" slot="iqd_sample5">
            <label class="weui-form-preview__label">{{customLabel.iqd_sample5 || "样本5"}}</label>
            <span class="weui-form-preview__value">{{
             item.iqd_sample5
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.iqd_sample6" slot="iqd_sample6">
            <label class="weui-form-preview__label">{{customLabel.iqd_sample6 || "样本6"}}</label>
            <span class="weui-form-preview__value">{{
             item.iqd_sample6
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.iqd_sample7" slot="iqd_sample7">
            <label class="weui-form-preview__label">{{customLabel.iqd_sample7 || "样本7"}}</label>
            <span class="weui-form-preview__value">{{
             item.iqd_sample7
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.iqd_sample8" slot="iqd_sample8">
            <label class="weui-form-preview__label">{{customLabel.iqd_sample8 || "样本8"}}</label>
            <span class="weui-form-preview__value">{{
             item.iqd_sample8
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.iqd_sample9" slot="iqd_sample9">
            <label class="weui-form-preview__label">{{customLabel.iqd_sample9 || "样本9"}}</label>
            <span class="weui-form-preview__value">{{
             item.iqd_sample9
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.iqd_sample10" slot="iqd_sample10">
            <label class="weui-form-preview__label">{{customLabel.iqd_sample10 || "样本10"}}</label>
            <span class="weui-form-preview__value">{{
             item.iqd_sample10
            }}</span>
          </div>
           </custom-layout>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
   components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/storage/ipqc/",
      caller: "Ipqc",
      xtype: "stock-ipqc-formpanel",
    };
  },
};
</script>